import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import actions from "../Store/actions";
import config from "../config";

/**
 * SignIn Component - executed when Azure Sign In after successful
 * authentications redirect to this component. At the end of the url
 * Azure appends #id_token
 */
const SignIn = () => {
    const dispatch = useDispatch();
    const { hash } = useLocation();
    const navigate = useNavigate();

    useEffect(async () => {
        const idToken = hash.split("#id_token=")[1];

        if (idToken) {
            await dispatch(actions.auth.create.getRequest({ idToken }));
            navigate(`/${config.paths.auth}`);
        } else navigate(`/${config.paths.login}`);
    }, []);

    return null;
};

export default SignIn;
